import { z } from 'zod';

export const CreateUserDtoSchema = z.object({
  email: z.string().email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  username: z.string().min(1),
  password: z.string().min(6),
  phone: z.string().optional(),
  jobTitle: z.string().optional(),
  department: z.string().optional(),
  isActive: z.boolean().optional(),
  roleIds: z.array(z.string().uuid()).optional(),
});

export type CreateUserDto = z.infer<typeof CreateUserDtoSchema>;

export const UpdateUserDtoSchema = z.object({
  email: z.string().email().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  username: z.string().optional(),
  phone: z.string().optional(),
  jobTitle: z.string().optional(),
  department: z.string().optional(),
  password: z.string().min(6).optional(),
  isActive: z.boolean().optional(),
});

export type UpdateUserDto = z.infer<typeof UpdateUserDtoSchema>;

export const AssignRolesDtoSchema = z.object({
  roleIds: z.array(z.string().uuid()),
});

export type AssignRolesDto = z.infer<typeof AssignRolesDtoSchema>;

export const QueryUsersDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
  isActive: z.coerce.boolean().optional(),
});

export type QueryUsersDto = z.infer<typeof QueryUsersDtoSchema>;

export const CreateRoleDtoSchema = z.object({
  name: z.string().min(1),
  description: z.string().optional(),
  isActive: z.boolean().optional(),
  permissionIds: z.array(z.string().uuid()).optional(),
});

export type CreateRoleDto = z.infer<typeof CreateRoleDtoSchema>;

export const UpdateRoleDtoSchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
  isActive: z.boolean().optional(),
  permissionIds: z.array(z.string().uuid()).optional(),
});

export type UpdateRoleDto = z.infer<typeof UpdateRoleDtoSchema>;

export const QueryRolesDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
  isActive: z.coerce.boolean().optional(),
});

export type QueryRolesDto = z.infer<typeof QueryRolesDtoSchema>;

export const CreatePermissionDtoSchema = z.object({
  name: z.string().min(1),
  description: z.string().optional(),
});

export type CreatePermissionDto = z.infer<typeof CreatePermissionDtoSchema>;

export const UpdatePermissionDtoSchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});

export type UpdatePermissionDto = z.infer<typeof UpdatePermissionDtoSchema>;

export const QueryPermissionsDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
});

export type QueryPermissionsDto = z.infer<typeof QueryPermissionsDtoSchema>;

export const CreateSolicitudDtoSchema = z.object({
  keycloakId: z.string(),
  email: z.string().email(),
});

export type CreateSolicitudDto = z.infer<typeof CreateSolicitudDtoSchema>;

export const ApproveSolicitudDtoSchema = z.object({
  roleIds: z.array(z.string().uuid()),
});

export type ApproveSolicitudDto = z.infer<typeof ApproveSolicitudDtoSchema>;

export const RejectSolicitudDtoSchema = z.object({
  reason: z.string().optional(),
});

export type RejectSolicitudDto = z.infer<typeof RejectSolicitudDtoSchema>;

export const QuerySolicitudesDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  status: z.string().optional(),
});

export type QuerySolicitudesDto = z.infer<typeof QuerySolicitudesDtoSchema>;

export const QueryKeycloakUsersDtoSchema = z.object({
  limit: z.coerce.number().int().min(0).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
  search: z.string().optional(),
  linked: z.coerce.boolean().optional(),
});

export type QueryKeycloakUsersDto = z.infer<typeof QueryKeycloakUsersDtoSchema>;
